"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoltAbilityHandler = exports.BoltActorAbilityFactory = exports.BoltAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Duration_1 = require("../../core/Duration");
const Convulsions_1 = require("../../core/effects/core/Convulsions");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class BoltAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Bolt;
        this.__typeName = "Bolt";
    }
}
exports.BoltAbilityArgs = BoltAbilityArgs;
let BoltActorAbilityFactory = class BoltActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Bolt", "OneEnemies", 0);
    }
};
BoltActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Bolt")
], BoltActorAbilityFactory);
exports.BoltActorAbilityFactory = BoltActorAbilityFactory;
let BoltAbilityHandler = class BoltAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Nature", 50)
            ],
            onHitOrMiss: (sequence, { hit }) => sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet")
                : LocationSelector_1.ActorVfxLocationSelector.Miss(selectedEnemy), "BlueLightningOrb")),
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Ticks(8),
                    effect: new Convulsions_1.ConvulsionsEffectArgs("Focus", 10),
                });
            },
        });
    }
};
BoltAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Bolt)
], BoltAbilityHandler);
exports.BoltAbilityHandler = BoltAbilityHandler;
